import { EdgeApiResponse } from './utilities'

export interface ImageSecurityConfig {
    snaps: {
        token: string | undefined
        /**
         * Not returned by the endpoint: the device time after which snapshot
         * URLs stop using the token, set by startImageSecurityRefresh.
         */
        usableUntil?: number
    }
    img: {
        /**
         * Returned by the endpoint but not consumed: avatars are screened
         * SFW and requested without a token (see avatarUrl).
         */
        token_params?: {
            mfca: string | undefined
        }
    }
}

export interface ImageSecurityTokensResponse extends EdgeApiResponse {
    result: ImageSecurityConfig
}

// bounds the request: a hung fetch settles into the tokenless fallback
// instead of staying pending indefinitely. It does not release
// age-gated previews from their placeholder — those still need a snaps
// token or the gate to clear (previewSnapshotUrl). Manual controller
// because Safari 15 lacks AbortSignal.timeout.
const TOKEN_FETCH_TIMEOUT_MS = 4000

export async function getImageSecurityTokens(forceBlur?: boolean) {
    const controller = new AbortController()
    const timeout = setTimeout(() => controller.abort(), TOKEN_FETCH_TIMEOUT_MS)
    try {
        const response = await fetch(
            // ?mode=1 for invalid hashes w/testing
            `https://api-edge.myfreecams.com/token/assets${forceBlur ? '?mode=1' : ''}`,
            {
                method: 'GET',
                credentials: 'include',
                signal: controller.signal,
            },
        )
        const json: ImageSecurityTokensResponse = await response.json()
        return json.result
    } catch (ex) {
        console.error(`[getImageSecurityTokens] error:`, ex)
        // invalid tokens will return "451 Unavailable For Legal Reasons"
        return {
            snaps: {
                token: undefined,
            },
            img: {
                token_params: undefined,
            },
        }
    } finally {
        clearTimeout(timeout)
    }
}
